module.exports = __webpack_public_path__ + "img/organic-products.10796d87.jpg";